export default __webpack_public_path__ + "static/media/diploma.05bb5e53.png";